import { ResourceData } from "shared/Models/resourceClasses";
import moment from 'moment';
import shortid from 'shortid';

export class Trip {
    constructor(obj: any = null){
        if(obj) {
            this.deptStation = obj.deptStation || "";
            this.arrvStation = obj.arrvStation || "";
            this.deptDate = obj.deptDate || "";
            this.recordLocator = obj.recordLocator || "";
            this.returnDate = obj.returnDate || "";
        }
    };

    deptStation: string = "";
    arrvStation: string = "";
    deptDate: string = "";
    recordLocator: string = "";
    returnDate: string = "";
}

export class TripHistory {
    constructor(obj: any = null){
        if(obj) {
            this.bookingDetails = new TripBookingDetails(obj.bookingDetails);
            this.departureFlight = new Journey(obj.departureFlight);
            this.receipt = new TripReceipt(obj.receipt);
            this.returnFlight = new Journey(obj.returnFlight);
            this.total = new TripTotal(obj.total);
        }
    };

    bookingDetails = new TripBookingDetails();
    departureFlight = new Journey();
    receipt = new TripReceipt();
    returnFlight = new Journey();
    total = new TripTotal();
}

export class LoadedTrip {
    constructor(obj: any = null) {
        if (obj) {
            this.loadedDeptStation = obj.loadedDeptStation || "";
            this.loadedArrvStation = obj.loadedArrvStation || "";
            this.loadedDeptDate = obj.loadedDeptDate || "";
            this.loadedRecordLocator = obj.loadedRecordLocator || "";
            this.loadedReturnDate = obj.loadedReturnDate || "";
        }
    };

    loadedDeptStation: string = "";
    loadedArrvStation: string = "";
    loadedDeptDate: string = "";
    loadedRecordLocator: string = "";
    loadedReturnDate: string = "";
}

export class DiscountDenData {
    constructor(obj: any = null){
        if(obj) {
            this.memberSince = obj.memberSince || "";
            this.savingsAmount = obj.savingsAmount || "";
            this.discountDenPrice = obj.discountDenPrice || 0;
            this.isDiscountDen = !!obj.isDiscountDen;
            this.discountDenEnrollmentFeeAmount = obj.discountDenEnrollmentFeeAmount || 0;
            this.discountDenSignupFeeAmount = obj.discountDenSignupFeeAmount || 0;
        }
    };
   memberSince: string = "";
   savingsAmount: string = "";
   discountDenPrice: number = 0;
   isDiscountDen: boolean = false;
   discountDenEnrollmentFeeAmount: number = 0;
   discountDenSignupFeeAmount: number = 0;
}

export class WildPassData {
    constructor(obj: any = null){
        if(obj) {
            this.memberSince = obj.memberSince || "";
            this.savingsAmount = obj.savingsAmount || "";
            this.price = obj.price || 0;
            this.hasWildPass = !!obj.hasWildPass;
            this.expirationDate = obj.expirationDate || "";
            this.totalFeeAmount = obj.totalFeeAmount || "";
            this.finalSignupAmount = obj.finalSignupAmount || "";
            this.subProgramCode = obj.subProgramCode || "";
            this.accessStart = obj.accessStart || "";
            this.wildPassName = obj.wildPassName || "";
            this.passMembershipInfo = new PassMembershipInfo(obj.passMembershipInfo);
        }
    };
    expirationDate: string = "";
    memberSince: string = "";
    savingsAmount: string = "";
    price: number = 0;
    hasWildPass: boolean = false;
    totalFeeAmount: string = "";
    finalSignupAmount: string = "";
    subProgramCode: string = "";
    accessStart: string = "";
    wildPassName: string = "";
    passMembershipInfo = new PassMembershipInfo();
}

export class PassMembershipInfo {
    constructor(obj: any = null) {
        if (obj) {
            this.membershipDescription = obj.membershipDescription || "";       
        }
    };
    membershipDescription = "";
}

export class PoolMember {
    constructor(obj: any = null){
        if(obj) {
            this.id = obj.id || "";
            this.name = obj.name || "";
            this.current = !!obj.current;
            this.head = !!obj.head;
            this.description = obj.description || "";
            this.avatar = obj.avatar || "";
            this.miles = obj.miles || "";
            this.expiration = obj.expiration || "";
        }
    };

    id: Number = 0;
    name: string = "";
    current: boolean = false;
    head: boolean = false;
    description: string = "";
    avatar: string = "";
    miles: string = "";
    expiration: string = "";
}

export class PoolData {
    constructor(obj: any = null){
        if(obj) {
            this.poolMiles = obj.poolMiles || "";
            this.coolDownEndDate = obj.coolDownEndDate || "";
            this.coolDownReason = obj.coolDownReason || "";
            this.isHead = !!obj.isHead;
            this.canCreatePool = !!obj.canCreatePool;
            this.poolNumber = obj.poolNumber;

            //arrays
            this.members = (obj.members || []).map((x: any) => new PoolMember(x));
        }
    };

    poolNumber: Number = 0;
    poolMiles: string = "";
    members: PoolMember[] = [];
    isHead: boolean = false;
    canCreatePool: boolean = false;
    coolDownReason: string = "";
    coolDownEndDate: string = "";
}

export class AircraftTail {
    constructor(obj: any = null){
        if(obj) {
            this.tailId = obj.tailId || "";
            this.aircraftName = obj.aircraftName || "";
            this.animalTag = obj.animalTag || "";
        }
    };

    tailId: string = "";
    aircraftName: string = "";
    animalTag: string = "";
}

export class MyMilesData {
    constructor(obj: any = null){
        if(obj) {
            this.currentAwardMiles = obj.currentAwardMiles || 0;
            this.milesToNextAward = obj.milesToNextAward || "";
            this.earnedOffPeakFlights = obj.earnedOffPeakFlights || 0;
            this.currentStatusMiles = obj.currentStatusMiles || "";
            this.numberOfCurrentStatusMiles = obj.numberOfCurrentStatusMiles || 0;
            this.milesToNextStatus = obj.milesToNextStatus || "";
            this.milesToNextAwardFlight = obj.milesToNextAwardFlight || "";
        }
    };

    currentAwardMiles: number = 0;
    milesToNextAward: string = "";
    earnedOffPeakFlights: number = 0;
    currentStatusMiles: string = "";
    numberOfCurrentStatusMiles: number = 0;
    milesToNextStatus: string = "";
    milesToNextAwardFlight: string = "";
}

export class AccountTransaction {
    constructor(obj: any = null){
        if(obj) {
            this.date = obj.date || "";
            this.description = obj.description || "";
            this.qualifyingMiles = obj.qualifyingMiles || "";
            this.redeemableMiles = obj.redeemableMiles || "";
        }
    };

    date: string = "";
    description: string = "";
    qualifyingMiles: string = "";
    redeemableMiles: string = "";
}

export class MyCity {
    constructor(obj: any = null){
        if(obj) {
            this.code = obj.code || "";
            this.name = obj.name || "";
            this.timesTraveled = obj.timesTraveled || "";
            this.lastVisited = obj.lastVisited || "";
            this.isLikedCity = !!obj.isLikedCity;
            this.imageUrl = obj.imageUrl || "";
            this.bookNowUrl = obj.bookNowUrl || "";
        }
    };

    code: string = "";
    name: string = "";
    timesTraveled: string = "";
    lastVisited: string = "";
    isLikedCity: boolean = false;
    imageUrl: string = "";
    bookNowUrl: string = "";
}

export class CardMilesData {
    constructor(obj: any = null){
        if(obj) {
            this.frontierMiles = obj.frontierMiles || "";
            this.diningMiles = obj.diningMiles || "";
            this.otherMiles = obj.otherMiles || "";
        }
    };

    frontierMiles: string = "";
    diningMiles: string = "";
    otherMiles: string = "";
}

export class TripData {
    constructor(obj: any = null) {
        if(obj) {
            //arrays
            this.pastTrips = (obj.pastTrips || []).map((x: any) => new Trip(x));
            this.upcomingTrips = (obj.upcomingTrips || []).map((x: any) => new Trip(x));
            this.loadedTrip = (obj.loadedTrip || []).map((x: any) => new Trip(x));
        }
    }
    pastTrips: Trip[] = [];
    upcomingTrips: Trip[] = [];
    loadedTrip: Trip[] = [];
}

export class MemberAggregateData {
    constructor(obj: any = null){
        if(obj){
            this.isDistanceFlownTrackingEnabled = !!obj.isDistanceFlownTrackingEnabled;
            this.placesTraveledAria = obj.placesTraveledAria || "";
            this.distanceFlown = obj.distanceFlown || "";
            this.homeAirport = obj.homeAirport || "";
            this.totalMiles = obj.totalMiles || "";
            this.defaultTailImage = obj.defaultTailImage || "";
            this.tailImageUrlFormat = obj.tailImageUrlFormat || "";

            //classes
            this.mastercardMilesData = new CardMilesData(obj.mastercardMilesData);
            this.loyaltyPool = new PoolData(obj.loyaltyPool);
            this.discountDenData = new DiscountDenData(obj.discountDenData);
            this.wildPassData = new WildPassData(obj.wildPassData);

            //arrays
            this.placesTraveled = obj.placesTraveled || [];//basic types do not need to be mapped
            this.placeRegions = (obj.placeRegions || []).map((x: any) => new MemberPlaceRegion(x));
            this.myCities = (obj.myCities || []).map((x: any) => new MyCity(x));
            this.myTails = (obj.myTails || []).map((x: any) => new AircraftTail(x));
            this.milesExpiration = obj.milesExpiration || "";
        }
    };

    isDistanceFlownTrackingEnabled: boolean = false;
    myCities: MyCity[] = [];
    mastercardMilesData: CardMilesData = new CardMilesData();
    loyaltyPool: PoolData = new PoolData();
    placeRegions: MemberPlaceRegion[] = [];
    placesTraveled: string[] = [];
    placesTraveledAria: string = "";
    myTails: AircraftTail[] = [];
    distanceFlown: string = "";
    discountDenData: DiscountDenData = new DiscountDenData();
    wildPassData: WildPassData = new WildPassData();
    homeAirport: string =""
    milesExpiration: string = "";
    totalMiles: string = "";
    defaultTailImage: string = "";
    tailImageUrlFormat: string = "";
}

export class MemberCompanion {
    constructor(obj: any = null) {
        this.uid = shortid.generate();

        if(obj) {
            this.id = obj.id ? Number(obj.id) : this.id;
            this.milesNumber = obj.milesNumber ? Number(obj.milesNumber) : this.milesNumber;

            this.firstName = obj.firstName || this.firstName;
            this.middleName = obj.middleName || this.middleName;
            this.lastName = obj.lastName || this.lastName;
            this.gender = obj.gender || this.gender;
            this.passportNumber = obj.passportNumber || this.passportNumber;
            this.passportNationality = obj.passportNationality || this.passportNationality;
            this.passportCountry = obj.passportCountry || this.passportCountry;
            this.knownTravelerNumber = obj.knownTravelerNumber || this.knownTravelerNumber;
            this.redressNumber = obj.redressNumber || this.redressNumber;
            
            this.expanded = !!obj.expanded;
            this.passportExpanded = !!obj.passportExpanded;
            this.ktnExpanded = !!obj.ktnExpanded;
            this.redressExpanded = !!obj.redressExpanded;
            this.changed = !!obj.changed;

            this.dob = obj.dob ? moment.parseZone(obj.dob) : this.dob;
            this.expirationDate = obj.expirationDate ? moment.parseZone(obj.expirationDate) : this.expirationDate;

            if(obj.passportNumber) {
                this.passport = new SettingsPassport({
                    firstName: obj.firstName,
                    middleName: obj.middleName,
                    lastName: obj.lastName,
                    documentNumber: obj.passportNumber,
                    expirationDate: obj.expirationDate,
                    nationality: obj.passportNationality,
                    issuingCountry: obj.passportCountry
                });
            } else {
                this.passport = new SettingsPassport();
            }
        }
    }

    uid: String = "";
    id: Number | null = null;
    milesNumber: Number | null = null;

    firstName: String = "";
    middleName: String = "";
    lastName: String = "";
    gender: String = "";
    passportNumber: String = "";
    passportNationality: String = "";
    passportCountry: String = "";
    knownTravelerNumber: String = "";
    redressNumber: String = "";

    expanded: Boolean = false;
    passportExpanded: Boolean = false;
    ktnExpanded: Boolean = false;
    redressExpanded: Boolean = false;
    changed: Boolean = false;

    dob: Date | null = null;
    expirationDate: Date | null = null;

    passport: SettingsPassport | null = null;
}

export class MemberPlaceRegion {
    constructor(obj: any = null) {
        if(obj) {
            this.name = obj.name;
            this.abbreviation = obj.abbreviation;
            this.resolution = obj.resolution;
        }
    }

    name: string = "";
    abbreviation: string = "";
    resolution: string = "";
}

export class MemberCustomerData {
    constructor(obj: any = null) {
        if(obj){
            this.statusQualifyingMiles = obj.statusQualifyingMiles || "";
            this.statusExpiration = obj.statusExpiration || "";
            this.membershipDate = obj.membershipDate || "";
            this.queryTimespan = obj.queryTimespan || "";

            //classes
            this.myMiles = new MyMilesData(obj.myMiles);
            this.accountInfo = new SettingsAccountInfo(obj.accountInfo);

            //arrays
            this.accountTransactions = (obj.accountTransactions || []).map((x: any) => new AccountTransaction(x));

            this.discountDenExpirationDate = obj.discountDenExpirationDate || "";
            this.isDiscountDenAutoRenewed = !!obj.isDiscountDenAutoRenewed;
            this.wildPassExpirationDate = obj.wildPassExpirationDate || "";            
            this.isWildPassAutoRenewed = !!obj.isWildPassAutoRenewed;
            this.barclaysMilesYtd = obj.barclaysMilesYtd || "";
            this.frontierMilesFlownYtd = obj.frontierMilesFlownYtd || "";
        }
    };

    myMiles: MyMilesData = new MyMilesData();
    accountInfo: SettingsAccountInfo = new SettingsAccountInfo();
    accountTransactions: AccountTransaction[] = [];
    statusQualifyingMiles: string = "";
    statusExpiration: string = "";
    membershipDate: string = "";
    queryTimespan: string = "";
    discountDenExpirationDate: string = "";
    isDiscountDenAutoRenewed: boolean = false;
    wildPassExpirationDate: string = "";
    isWildPassAutoRenewed: boolean = false;
    barclaysMilesYtd: string = "";
    frontierMilesFlownYtd: string = "";
}

export class MemberBaseData {
    constructor(obj: any = null) {
        if(obj){
            this.number = obj.number || 0;
            this.name = obj.name || "";
            this.firstName = obj.firstName || "";
            this.lastName = obj.lastName || "";
            this.email = obj.email || "";
            this.image = obj.image || "";
            this.statusName = obj.statusName || "";
            this.totalMiles = obj.totalMiles || "";
            this.currentMiles = obj.currentMiles || "";
            this.cardMiles = obj.cardMiles || "";
            this.isBarclaysMember = !!obj.isBarclaysMember;
            this.isDiscountDenMember = !!obj.isDiscountDenMember;
            this.isDiscountDenEligible = !!obj.isDiscountDenEligible;
            this.isWildPassMember = !!obj.isWildPassMember;
            this.isWildPassEligible = !!obj.isWildPassEligible;
            this.isLoggedIn = !!obj.isLoggedIn;
            this.isNDCLoggedIn = !!obj.isNDCLoggedIn;
            this.pointsUrl = obj.pointsUrl || "";
            this.barclaysBannerTitle = obj.barclaysBannerTitle || "";
            this.barclaysBannerSubtitle = obj.barclaysBannerSubtitle || "";
            this.barclaysCreditCardImageUrl = obj.barclaysCreditCardImageUrl || "";
            this.barclaysFrontierCreditCardLink = obj.barclaysFrontierCreditCardLink || "";
            this.barclaysFamilityPoolingLink = obj.barclaysFamilityPoolingLink || "";
            this.barclaysStatusBenefitsLink = obj.barclaysStatusBenefitsLink || "";
            this.barclaysStatusBreakdownLink = obj.barclaysStatusBreakdownLink || "";
            this.loyaltySectionsEnrolledMemberAccess = obj.loyaltySectionsEnrolledMemberAccess || [];
            this.programLevel = obj.programLevel || "";
            this.effectiveDate = obj.effectiveDate || "";
            this.levelName = obj.levelName || "";
            this.qualifyingPoints = obj.qualifyingPoints || 0;
        } else {
            this.isLoggedIn = false;
        }
    };

    number: number = 0;
    name: string = "";
    firstName: string = "";
    lastName: string = "";
    email: string = "";
    image: string = "";
    statusName: string = "";
    totalMiles: string = "";
    currentMiles: string = "";
    cardMiles: string = "";
    isBarclaysMember: boolean = false;
    isDiscountDenMember: boolean = false;
    isDiscountDenEligible: boolean = true;
    isWildPassMember: boolean = false;
    isWildPassEligible: boolean = true;
    isLoggedIn: boolean = false;
    isNDCLoggedIn: boolean = false;
    pointsUrl: string = "";
    barclaysBannerTitle: string = "";
    barclaysBannerSubtitle: string = "";   
    barclaysCreditCardImageUrl: string = "";
    barclaysFrontierCreditCardLink: string = "";
    barclaysFamilityPoolingLink: string = "";
    barclaysStatusBenefitsLink: string = "";
    barclaysStatusBreakdownLink: string = "";
    loyaltySectionsEnrolledMemberAccess: Array<object> = [];
    programLevel: string = "";
    effectiveDate: string = "";
    levelName: string = "";
    qualifyingPoints: number = 0;
}

export class Member {
    constructor(obj:any = null){
        if(obj){
            this.memberData = new MemberBaseData(obj.memberData);
            this.aggregateData = new MemberAggregateData(obj.aggregateData);
            this.customerData = new MemberCustomerData(obj.customerData);
            this.resourceData = new ResourceData(obj.resourceData);
            this.tripData = new TripData(obj.tripData);
        }
    };

    //Member data is populated from the view models (existing member profile)
    memberData: MemberBaseData = new MemberBaseData();
    //Aggregate data is populated from the Cosmos database
    aggregateData: MemberAggregateData = new MemberAggregateData(); 
    //Customer data is populated from the  APIs
    customerData: MemberCustomerData = new MemberCustomerData();
    //Resource data from extended resource cache
    resourceData: ResourceData = new ResourceData();
    //9 Past and upcoming trips
    tripData: TripData = new TripData();
}

export class TripBookingDetails {
    constructor(obj: any = null){
        if(obj){
            this.confirmationNumber = obj.confirmationNumber || "";
            this.departureDate = obj.departureDate || "";
            this.arrivalDate = obj.arrivalDate || "";
            this.isRoundtrip = !!obj.isRoundtrip;
            this.departureStationCode = obj.departureStationCode || "";
            this.departureStationName = obj.departureStationName || "";
            this.arrivalStationCode = obj.arrivalStationCode || "";
            this.arrivalStationName = obj.arrivalStationName || "";
            this.passengers = (obj.passengers || []).map((x: any) => new String(x));
        }
    };

    confirmationNumber: string = "";
    departureDate: string = "";
    arrivalDate: string = "";
    isRoundtrip: boolean = false;
    departureStationCode: string = "";
    departureStationName: string = "";
    arrivalStationCode: string = "";
    arrivalStationName: string = "";
    passengers: String[] = [];
}

export class TripDetailsPassenger {
    constructor(obj: any = null){
        if(obj){
            this.name = obj.name || "";
            this.seat = obj.seat || "";
            this.bags = obj.bags || "";
            this.specialServices = obj.specialServices || "";
        }
    };

    name: string = "";
    seat: string = "";
    bags: string = "";
    specialServices: string = "";
}

export class ReceiptAirfareOther {
    constructor(obj: any = null){
        if(obj){
            this.description = obj.description || "";
            this.amount = obj.amount || "";
        }
    };

    description: string = "";
    amount: string = "";
}

export class ReceiptOption {
    constructor(obj: any = null){
        if(obj){
            this.description = obj.description || "";
            this.amount = obj.amount || "";
        }
    };

    description: string = "";
    amount: string = "";
}

export class Journey {
    constructor(obj: any = null){
        if(obj){
            this.flightNumber = obj.flightNumber || "";
            this.departureDate = obj.departureDate || "";
            this.depatureStationName = obj.depatureStationName || "";
            this.arrivalDate = obj.arrivalDate || "";
            this.arrivalStationName = obj.arrivalStationName || "";
            this.duration = obj.duration || "";

            //arrays
            this.passengers = (obj.passengers || []).map((x: any) => new TripDetailsPassenger(x));
        }
    };

    flightNumber: string = "";
    departureDate: string = "";
    depatureStationName: string = "";
    arrivalDate: string = "";
    arrivalStationName: string = "";
    duration: string = "";
    passengers: TripDetailsPassenger[] = [];
}

export class ReceiptAirfare {
    constructor(obj: any = null){
        if(obj){
            this.flightsAmount = obj.flightsAmount || "";
            this.discountsAmount = obj.discountsAmount || "";

            this.others = (obj.others || []).map((x: any) => new ReceiptAirfareOther(x));
        }
    };

    flightsAmount: string = "";
    discountsAmount: string = "";
    others: ReceiptAirfareOther[] = [];
}

export class TripReceipt {
    constructor(obj: any = null){
        if(obj){
            //classes
            this.airfare = new ReceiptAirfare(obj.airfare);

            //arrays
            this.options = (obj.options || []).map((x: any) => new ReceiptOption(x));
        }
    };

    airfare: ReceiptAirfare = new ReceiptAirfare();
    options: ReceiptOption[] = [];
}

export class TripPayment {
    constructor(obj: any = null){
        if(obj){
            this.type = obj.type || "";
            this.number = obj.number || "";
            this.amount = obj.amount || "";
            this.status = obj.status || "";
            this.expirationDate = obj.expirationDate || "";
        }
    };

    type: string = "";
    number: string = "";
    amount: string = "";
    status: string = "";
    expirationDate: string = "";
}

export class TripTotal {
    constructor(obj: any = null){
        if(obj){
            this.totalAmount = obj.totalAmount || "";
            this.purchaseDate = obj.purchaseDate || "";

            //arrays
            this.payments = (obj.payments || []).map((x: any) => new TripPayment(x));
        }
    };

    totalAmount: string = "";
    purchaseDate: string = "";
    payments: TripPayment[] = [];
}

export class TripDetails {
    constructor(obj: any = null){
        if(obj){
            this.bookingDetails = new TripBookingDetails(obj.bookingDetails);
            this.departureFlight = new Journey(obj.departureFlight);
            this.returnFlight = new Journey(obj.returnFlight);
            this.receipt = new TripReceipt(obj.receipt);
            this.total = new TripTotal(obj.total);
        }
    };

    bookingDetails: TripBookingDetails = new TripBookingDetails();
    departureFlight: Journey = new Journey();
    returnFlight: Journey = new Journey();
    receipt: TripReceipt = new TripReceipt();
    total: TripTotal = new TripTotal();
}

export class SettingsPasswordUpdate {
    constructor(obj: any = null){
        if(obj){
            this.oldPassword = obj.oldPassword || "";
            this.oldPassword = obj.oldPassword || "";
        }
    };

    oldPassword: string = "";
    newPassword: string = "";
}

export class SettingsAccountInfo {
    constructor(obj: any = null){
        if(obj){
            this.animalCode = obj.animalCode || "";
            this.firstName = obj.firstName || "";
            this.middleName = obj.middleName || "";
            this.lastName = obj.lastName || "";
            this.suffix = obj.suffix || "";
            this.phoneNumber = obj.phoneNumber || "";
            this.gender = obj.gender || "";
            this.dateOfBirth = moment.parseZone(obj.dateOfBirth || "1/1/1980");
            this.countryOfResidence = obj.countryOfResidence || "";
            this.address1 = obj.address1 || "";
            this.address2 = obj.address2 || "";
            this.city = obj.city || "";
            this.state = obj.state || "";
            this.zipCode = obj.zipCode || "";
            this.emailAddress = obj.emailAddress || "";
        }
    };

    animalCode: string="";
    firstName: string = "";
    middleName: string = "";
    lastName: string = "";
    suffix: string = "";
    phoneNumber: string = "";
    gender: string = "";
    dateOfBirth: Date = new Date(1980, 1, 1);
    countryOfResidence: string = "";
    address1: string = "";
    address2: string = "";
    city: string = "";
    state: string = "";
    zipCode: string = "";
    emailAddress: string = "";
}

export class SettingsEmail {
    constructor(obj: any = null){
        if(obj){
            this.oldEmail = obj.oldEmail || "";
            this.newEmail = obj.newEmail || "";
        }
    };

    oldEmail: string = "";
    newEmail: string = "";
}

export class SettingsCardBillingAddress {
    constructor(obj: any = null){
        if(obj){
            this.country = obj.country || "";
            this.address1 = obj.address1 || "";
            this.address2 = obj.address2 || "";
            this.city = obj.city || "";
            this.state = obj.state || "";
        }
    };

    country: string = "";
    address1: string = "";
    address2: string = "";
    city: string = "";
    state: string = "";
}

export class SettingsCreditCard {
    constructor(obj: any = null){
        if(obj){
            this.number = obj.number || "";
            this.cardholderName = obj.cardholderName || "";
            this.expMonth = obj.expMonth || 1;
            this.expYear = obj.expYear || 1900;
            this.paymentId = obj.paymentId || 0;
            this.paymentMethodCode = obj.paymentMethodCode || "";
            this.isDefault = obj.isDefault || false;
            this.submitted = obj.submitted || false;
        }
    };
    number: string = "";
    cardholderName: string = "";
    expMonth: number = 1;
    expYear: number = 1900;
    paymentId: number = 0;
    paymentMethodCode: string = "";
    isDefault: boolean = false;
    submitted: boolean = false;
}

export class SettingsCreditCards {
    constructor(obj: any = null) {
        if (obj) {
            this.settingsCreditCards = (obj.settingsCreditCards || []).map((x: any) => new SettingsCreditCard(x));
        }
    }

    settingsCreditCards: SettingsCreditCard[] = [];
}

export class SettingsTravelPreferences {
    constructor (obj: any = null){
        if(obj) {
            this.passports = (obj.passports || []).map((x: any) => new SettingsPassport(x));
            this.companions = (obj.companions || []).map((x: any) => new MemberCompanion(x));
            this.companionsToDelete = obj.companionsToDelete || [];
            this.knownTravelerNumber = new SettingsKnowTravelerNumber(obj.knownTravelerNumber);
            this.redressNumber = new SettingsRedressNumber(obj.redressNumber);
            this.seatLocation = obj.seatLocation || "";
            this.seatType = obj.seatType || "";

        }
    }
    
    passports: SettingsPassport[] = [];
    companions: MemberCompanion[] = [];
    companionsToDelete: Number[] = [];
    knownTravelerNumber: SettingsKnowTravelerNumber = new SettingsKnowTravelerNumber();
    redressNumber: SettingsRedressNumber = new SettingsRedressNumber();
    seatLocation: string = "";
    seatType: string = "";
}

export class SettingsTravelDocument {
    constructor(obj: any = null) {
        if (obj) {
            this.firstName = obj.firstName || "";
            this.lastName = obj.lastName || "";
            this.middleName = obj.middleName || "";
            this.issuingCountry = obj.issuingCountry || "";
            this.nationality = obj.nationality || "";
            this.issueDate = obj.issueDate ? moment.parseZone(obj.issueDate) : null;
            this.issueDateFormatted = obj.issueDateFormatted || "";
            this.expirationDate = obj.expirationDate ? moment.parseZone(obj.expirationDate) : null
            this.expirationDateFormatted = obj.expirationDateFormatted || "";
            this.documentId = obj.documentId || 0;
            this.documentNumber = obj.documentNumber || "";
        }
    }
    firstName: string = "";
    lastName: string = "";
    middleName: string = "";
    issuingCountry: string = "";
    nationality: string = "";
    issueDate: Date | null = null;
    issueDateFormatted: string = "";
    expirationDate: Date | null = null;
    expirationDateFormatted: string = "";
    documentId: number = 0;
    documentNumber: string = "";
}

export class SettingsPassport extends SettingsTravelDocument {
    constructor(obj: any = null) {
        super(obj);
        if (obj) {
            this.documentType = obj.documentType || "P";
            this.id = obj.id || "";
        }
    }
    documentType: string = "P";
    id: string = ""
}

export class SettingsPassports {
    constructor(obj: any = null) {
        if (obj) {
            this.settingsPassports = (obj.settingsPassports || []).map((x: any) => new SettingsPassport(x));
        }
    }

    settingsPassports: SettingsPassport[] = [];
}

export class SettingsKnowTravelerNumber extends SettingsTravelDocument {
    constructor(obj: any = null) {
        super(obj);
        if (obj) {
            this.documentType = obj.documentType || "K";
        }
    }
    documentType: string = "K";
}

export class SettingsRedressNumber extends SettingsTravelDocument {
    constructor(obj: any = null) {
        super(obj);
        if (obj) {
            this.documentType = obj.documentType || "R";
        }
    }
    documentType: string = "R";
}

